function getConstants() {
    if (window.location.hostname === 'localhost' || window.location.hostname === 'agrekordmobile.lh') {
        const BASE_URL = 'https://agrekordmobile.lh';
        return { // ServiceWorkerben is át kell írni, sajnos ezt a file-t nem éri el
            BASE_URL: BASE_URL,
            API_URL: BASE_URL + '/rest/v2/',
            POST_HEADER: { headers: { 'Content-Type': 'application/json' } },
            IDB_NAME: 'Agrekord',
            IDB_VERSION: 11,
            APP_VERSION: 'v1.0',
        };
    }

    let origin;
    const hostname = window.location.hostname;

    if (hostname.includes('agrekord.netkorzo.com')) {
        // staging környezet
        origin = window.location.origin.replace(/^https?:\/\/mobil\./, 'https://');
    } else if (hostname.includes('agrekord.hu')) {
        // production környezet
        origin = window.location.origin.replace(/^https?:\/\/mobil\./, 'https://app.');
    } 

    const API_URL = origin + '/rest/v2/';

    return { // ServiceWorkerben is át kell írni, sajnos ezt a file-t nem éri el
        BASE_URL: origin,
        API_URL: API_URL,
        POST_HEADER: { headers: { 'Content-Type': 'application/json' } },
        IDB_NAME: 'Agrekord',
        IDB_VERSION: 11,
        APP_VERSION: 'v1.1.0',
    };
}

const constants = getConstants();
export default constants;
